<template>
  <div class="loader-custom-container cell small-12 medium-12 large-12 xlarge-12">
    <div class="grid-x">
      <div class="cell small-12 medium-12 large-12 xlarge-12">
        <AtomicUiSkeleton height="22px" width="188px" />
      </div>
    </div>
    <div class="grid-x margin-top-m show-for-medium">
      <div class="cell small-12 medium-12 large-12 xlarge-12">
        <table class="loader-table-large">
          <thead>
            <tr>
              <th class="padding-top-xs padding-bottom-xs">
                <AtomicUiSkeleton height="22px" width="72px" />
              </th>
              <th class="padding-top-xs padding-bottom-xs">
                <AtomicUiSkeleton height="22px" width="34%" />
              </th>
              <th class="padding-top-xs padding-bottom-xs">
                <AtomicUiSkeleton height="22px" width="67%" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="index in 3" :key="index">
              <td class="padding-top-s padding-bottom-s padding-left-xxs">
                <div class="d-flex align-middle">
                  <AtomicUiSkeleton height="50px" width="50px" class="circular-loader" />
                  <AtomicUiSkeleton height="22px" width="31%" class="margin-left-xl" />
                </div>
              </td>
              <td class="padding-top-s padding-bottom-s">
                <AtomicUiSkeleton height="22px" width="34%" />
              </td>
              <td class="padding-top-s padding-bottom-s">
                <AtomicUiSkeleton height="22px" width="67%" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="grid-x margin-top-m show-for-small hide-for-medium">
      <div class="cell small-12 medium-12 large-12 xlarge-12">
        <div class="custom-border"></div>
        <AtomicUiSkeleton height="50px" class="margin-top-s" />
        <table class="loader-table-small margin-top-m">
          <tbody>
            <template v-for="index in 3" :key="index">
              <tr>
                <td class="padding-top-s padding-bottom-s padding-left-xs" colspan="2">
                  <div class="d-flex align-middle">
                    <AtomicUiSkeleton height="48px" width="48px" class="circular-loader" />
                    <AtomicUiSkeleton height="50px" class="margin-left-xs" />
                  </div>
                </td>
              </tr>
              <tr>
                <td class="padding-top-s padding-left-xs">
                  <AtomicUiSkeleton height="10px" width="73px" />
                  <AtomicUiSkeleton height="10px" width="73px" class="margin-top-xxs" />
                </td>
                <td class="padding-top-s align-right">
                  <AtomicUiSkeleton height="10px" width="73px" class="margin-left-auto" />
                  <AtomicUiSkeleton height="10px" width="73px" class="margin-left-auto margin-top-xxs" />
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~@core/foundation/scss/foundation-6.7.4/scss/prototype/_spacing.scss';

.loader-custom-container {
  @include breakpoint(small only) {
    @include margin-direction('top', map-get($spacer, 'xxs'));
    @include margin-direction('bottom', map-get($spacer, 'xs'));
  }
  @include breakpoint(medium up) {
    @include margin-direction('top', map-get($spacer, 's'));
    @include margin-direction('bottom', map-get($spacer, 'xxl'));
  }
}
.loader-table-large {
  width: 100%;
  border-spacing: initial;
  thead > tr > th {
    border: 0;
    border-bottom: 1px solid $hover-color;
  }
  thead > tr > th:nth-child(1) {
    width: 68%;
  }
  thead > tr > th:nth-child(2) {
    width: 17%;
  }
  thead > tr > th:nth-child(3) {
    width: 15%;
  }
  tbody > tr > td {
    border: 0;
    border-bottom: 1px solid $hover-color;
  }
  .circular-loader {
    border-radius: 50%;
    min-width: rem-calc(50);
  }
}
.loader-table-small {
  width: 100%;
  border-spacing: initial;
  .circular-loader {
    border-radius: 50%;
    min-width: rem-calc(48);
  }
  tbody > tr > td {
    border: 0;
  }
  tbody > tr:nth-child(2n + 1) > td {
    border-top: 1px solid $hover-color;
  }
  tbody > tr:nth-child(2n + 2) > td {
    width: 50%;
    padding-bottom: rem-calc(56);
  }
}
.custom-border {
  border-bottom: 1px solid $hover-color;
}
.d-flex {
  display: flex;
}
.margin-left-auto {
  margin-left: auto;
}
</style>
